import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AdminSubscribers() {
  const [subs, setSubs] = useState(null);

  useEffect(() => { api.get("/admin/subscribers").then((res) => setSubs(res.data)); }, []);

  return (
    <div data-testid="admin-subscribers-page">
      <h1 className="text-2xl font-serif-heading font-bold text-navy mb-6">Newsletter Subscribers ({subs?.length ?? "…"})</h1>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Email</TableHead><TableHead>Subscribed</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>
            {subs?.map((s) => (
              <TableRow key={s.id} data-testid={`admin-subscriber-row-${s.id}`}>
                <TableCell className="font-medium text-navy">{s.email}</TableCell>
                <TableCell className="text-sm text-slate-500">{new Date(s.subscribed_at).toLocaleDateString()}</TableCell>
                <TableCell className="text-sm text-slate-500">{s.status}</TableCell>
              </TableRow>
            ))}
            {subs?.length === 0 && <TableRow><TableCell colSpan={3} className="text-center text-slate-400 py-8">No subscribers yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
